import { getAwaitGambleAction } from 'automaton/actions/AwaitGambleAction'
import { getRequestGambleAction } from 'automaton/actions/RequestGambleAction'
import { getBetState } from 'automaton/states/BetState'

export function getGambleState() {

  const name = 'GAMBLE'
  const actions = [
    getRequestGambleAction(),
    getAwaitGambleAction(),
  ]
  const transition = () => getBetState()

  return {
    name,
    actions,
    transition,
  }
}
